var api = "https://api.qingcigame.com";
var Media = document.getElementById('media-play');
var mySwiper = null;
var obj = {
    index: function() {
        $('.index').removeClass('loading');
        this.preloading(); // 预加载
        this.indexSwiper(); // 首页大轮播
        this.indexBind();
        this.share();
        this.returnBntClickTouchstart();

        $('.swiper_prev_btn').hide();
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time p").text(parseInt(e.progress * 100) + '%')
            };

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.float-time').addClass('float-time-ani')
            $('.index').removeClass('loading');
            $('.bg').addClass('bg-ani');

            setTimeout(function() {
                $('.preloading').remove();
            }, 1000);
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/summer/images/mobile/role_l-59ffe3d064.png',
            '/summer/images/mobile/role_r-030ae2c4a8.png',
            '/summer/images/mobile/page_1_light-2479c90dd4.png',
            '/summer/images/mobile/trophy-48c935bf11.png',
            '/summer/images/mobile/title_img-4f05433cd8.png',
            '/summer/images/mobile/page_1-994372cf05.png',
            '/summer/images/mobile/share_img-994f03c17c.png'
        ]);
    },
    // 首页轮播
    indexSwiper: function() {

        mySwiper = new Swiper('.swiper-container', {
            // pagination: '.swiper-pagination',
            direction: 'horizontal',
            slidesPerView: 'auto',
            parallax: true,
            followFinger: false,
            speed: 1500,
            touchRatio: .7,
            spaceBetween: 100,
            mousewheelControl: true,
            resistanceRatio: 0,
            prevButton: '.swiper_prev_btn',
            nextButton: '.swiper_next_btn',
            mousewheel: {
                thresholdDelta: 110,
            },
            onInit: function(swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function() {
                        mySwiper.slideTo(page, 1500, true);
                        if(page == 0) {
                          $(".index .swiper-container .content_bg").fadeIn();
                        }
                    });
                }
                var aniLink01 = Ani('.tab_01', '0');
                var aniLink02 = Ani('.tab_02', '1');
                var aniLink03 = Ani('.tab_03', '2');
                var aniLink04 = Ani('.tab_04', '3');
                var aniLink05 = Ani('.tab_05', '4');
                var aniLink06 = Ani('.tab_06', '5');
                var aniLink07 = Ani('.tab_07', '6');

                // 点击弹窗背景关闭弹窗
                $('.mouse, .tab_02').click(function(event) {
                    $(".index .swiper-container .first_bg").addClass("page_bg_ani1").removeClass('page_bg_ani0');
                });
                
            },
            onSlideChangeStart: function(swiper) {
                swiperAnimate(swiper);
                $('.footer').removeClass('footer-on');
                $(".tab_0" + Number(swiper.activeIndex+1) + "").addClass("active").siblings().removeClass("active");

                for (var i = 6; i >= 0; i--) $(".first_bg").removeClass("page_bg_ani"+i+"");
                $(".index .swiper-container .first_bg").addClass("page_bg_ani"+swiper.activeIndex+"");
                
                if ([0, 3].includes(swiper.activeIndex)) {
                    setTimeout(() => {
                        $('.swiper_prev_btn').removeClass('swiper_prev_btn_2');
                        $('.swiper_next_btn').removeClass('swiper_next_btn_2');
                    }, 500);
                    
                } else {
                    setTimeout(() => {
                        $('.swiper_prev_btn').addClass('swiper_prev_btn_2');
                        $('.swiper_next_btn').addClass('swiper_next_btn_2');
                    }, 500);
                }

                if (swiper.activeIndex === 0) {
                    setTimeout(() => {
                        $('.swiper_prev_btn').hide();
                        $('.swiper_next_btn').show();
                    }, 500);
                } else if (swiper.activeIndex === 6) {
                    setTimeout(() => {
                        $('.swiper_prev_btn').show();
                        $('.swiper_next_btn').hide();
                    }, 500);
                } else {
                    setTimeout(() => {
                        $('.swiper_prev_btn').show();
                        $('.swiper_next_btn').show();
                    }, 500);
                }
            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
            },
        });
    },

    indexBind: function() {

        // 点击分享按钮-开启分享弹窗
        $('.share_btn').click(function() {
            $('.share-wrap').fadeIn();
            __bl.sum('夏日战斗季_移动端_分享弹窗');
        });

        // 关闭分享弹窗
        $('.share-wrap').on('click','.close-btn', function() {
            $('.share-wrap').fadeOut();
        });

        var clipboard = new Clipboard('.copy-btn');
            clipboard.on('success', function(e) {
            console.info('Action:', e.action);
            console.info('Text:', e.text);
            console.info('Trigger:', e.trigger);
            layer.msg("复制链接,快去分享给好友吧~", { time: 2000, anim: -1, isOutAnim: false  });
            e.clearSelection();
            __bl.sum('夏日战斗季_移动端_复制链接');
        });
        
        $('.official_btn').on('click', function() {
            __bl.sum('夏日战斗季_移动端_前往官网');
            var href = $(this).data('href');
            window.open(href);
        });

        $('.skill-icon .skill').click(function(event) {
            $(this).addClass('select').siblings().removeClass('select').parent('.skill-icon').siblings('.skill-desc').children('.desc').eq($(this).index()).addClass('show').siblings().removeClass('show');
        })

        $('.book-mmortal-btn').click(function() {
            layer.msg("敬请期待！", { time: 2000, anim: -1, isOutAnim: false });
        })

        $('.video-btn').click(function(event) {
            $('.video-wrap').fadeIn();
            Media.play();
            __bl.sum('夏日战斗季_移动端_视频弹窗');
        });

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut();
            Media.pause();
        });
        

        // 点击查看页尾
        $('.footer').click(function(event) {
            var _this = $(this);
            _this.hasClass('footer-on') ? _this.removeClass('footer-on') : _this.addClass('footer-on');
        });



    },

    returnBntClickTouchstart() {
        var startX, startY, moveEndX, moveEndY, X = 0, Y = 0;
        $('.swiper-container').on("touchstart", (event) => {
            var e = event.originalEvent
            startX = e.touches[0].pageX
            startY = e.touches[0].pageY
        });
   
        $('.swiper-container').on("touchmove", (event) => {
            // e.preventDefault();
   
            var e = event.originalEvent
            moveEndX = e.changedTouches[0].pageX
            moveEndY = e.changedTouches[0].pageY
            X = moveEndX - startX
            Y = moveEndY - startY
        })
   
        $('.swiper-container').on("touchend", (e) => {
            if (Math.abs(X) > Math.abs(Y) && X < 0 && Math.abs(X) > 60) {
                mySwiper && mySwiper.slideNext();
            } else if (Math.abs(X) > Math.abs(Y) && X > 0 && Math.abs(X) > 60) {
                mySwiper && mySwiper.slidePrev();
            } else if (Math.abs(Y) > Math.abs(X) && Y > 0 && Math.abs(Y) > 60) {
                mySwiper && mySwiper.slidePrev();
            } else if (Math.abs(Y) > Math.abs(X) && Y < 0 && Math.abs(Y) > 60) {
                mySwiper && mySwiper.slideNext();
            }
            moveEndX = 0
            moveEndY = 0
            X = 0
            Y = 0
        })
    },

    share: function() {
        
    }
}